import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { RoleService } from '../../services/role.service';
import { UserRole } from '../../shared/types/role.interface';

/**
 * Resolves the initial app URL without flashing the login page: validates an existing
 * session from storage, then navigates to the role home or `/login`.
 */
@Component({
  selector: 'app-auth-bootstrap',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth-bootstrap.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./auth-bootstrap.component.scss'],
})
export class AuthBootstrapComponent implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly roleService = inject(RoleService);

  ngOnInit(): void {
    if (typeof window === 'undefined') {
      return;
    }

    const user = this.auth.user();
    if (!user?.token) {
      this.router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    this.auth.validateToken().subscribe({
      next: () => {
        const u = this.auth.user();
        const role = u?.role as UserRole | undefined;
        const target = role != null ? this.roleService.getDefaultRoute(role) : '/dashboard';
        this.router.navigate([target], { replaceUrl: true });
      },
      error: () => {
        this.router.navigate(['/login'], { replaceUrl: true });
      },
    });
  }
}
